import React from 'react';
import cx from 'classnames';
import _ from 'lodash';

class FileDrop extends React.Component {
  _dragEventCount = 0
  static defaultProps = {
    clickToOpen: true,
    name: null,
    multiple: true,
    text: null,
    icon: null,
  }

  state = {
    isDragActive: false,
  }

  componentDidMount() {
    window.addEventListener('dragenter', this.onDragEnter, { capture: true });
    window.addEventListener('dragleave', this.onDragLeave, { capture: true });
    window.addEventListener("dragover", this.onDocumentOver);
    window.addEventListener('drop', this.onDrop, { capture: true });
  }

  onDocumentOver = e => {
    e.preventDefault();
    e.stopPropagation();
  }

  onDragEnter = e => {
    e.preventDefault();
    e.stopPropagation();
    this._dragEventCount++;
    if (this._dragEventCount === 1) {
      this.props.onDragEnter?.(e);
      this.setState({ isDragActive: true });
    }
  }

  onDragLeave = e => {
    e.preventDefault();
    e.stopPropagation();
    this._dragEventCount--;
    if (this._dragEventCount === 0) {
      this.props.onDragLeave?.(e);
      this.setState({ isDragActive: false });
    }
  }

  onDrop = e => {
    let { multiple } = this.props; 
    e.preventDefault();
    e.stopPropagation();

    this._dragEventCount = 0;
    this.setState({ isDragActive: false });

    let droppedFiles = e.dataTransfer ? e.dataTransfer.files : e.target.files;
    let max = multiple ? droppedFiles.length : 1;
    let files = [];
    for (let i = 0; i < max; i++) {
      let file = droppedFiles[i];
      file.src = URL.createObjectURL(file);
      files.push(file);
    }

    this.props.onDrop?.(files, e);
  }

  onClick = () => {
    if(this.props.clickToOpen)
      this.open();
  }

  open = () => {
    let fileInput = this.refs.fileInput;
    fileInput.value = null;
    fileInput.click();
  }

  render() {
    var { className, multiple, style, children, transparent, name } = this.props;
    var {isDragActive} = this.state;
    return (
      <div
        className={cx('g-file-drop', className, { active: isDragActive, transparent: transparent })}
        style={style}
        onClick={this.onClick}>
        <div className="drop-info">{ children }</div>
        <input
          type='file'
          ref='fileInput'
          style={{ display: 'none' }}
          multiple={multiple}
          name={name}
          onChange={this.onDrop}>
        </input>
      </div>);
  }
};
export default FileDrop;